import { Navigate } from 'react-router-dom'

import EmailValidation from '@/app/emailValidation'
import ForgotPassword from '@/app/forgotPassword'
import Login from '@/app/login'
import Logout from '@/app/logout'
import ResetPassword from '@/app/resetPassword'
import SignUp from '@/app/signUp'

import { PATHS } from './constants'

export const ROUTES = [
  {
    path: PATHS.FORGOT_PASSWORD,
    element: <ForgotPassword />,
  },
  {
    path: PATHS.LOGIN,
    element: <Login />,
  },
  {
    path: PATHS.RESET_PASSWORD,
    element: <ResetPassword />,
  },
  {
    path: PATHS.SIGN_UP,
    element: <SignUp />,
  },
  {
    path: PATHS.SIGN_UP_QR,
    element: <SignUp />,
  },
  {
    path: PATHS.EMAIL_VALIDATION,
    element: <EmailValidation />,
  },
  {
    path: PATHS.LOGOUT,
    element: <Logout />,
  },
  {
    path: '*',
    element: <Navigate to={PATHS.LOGIN} />,
  },
]
